import { useState, useEffect, useCallback } from "react";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { spedAction } from "../../../../redux/sped";
import useApiClient, { apiRoutes } from "../../../../hooks/apiClient";
import itensPagina from "../../../../components/Formatters/ItensPagina";

const useConsultaSped = ({ dadosOs }) => {
  const [totalRows, setTotalRows] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [pageNumber, setPageNumber] = useState(1);

  const dispacth = useDispatch();

  const { request, data, errors, isLoading } = useApiClient();

  const {
    request: requestDownload,
    data: dataDownload,
    errors: errorDownload,
    // isLoading: downloadIsLoading,
  } = useApiClient();

  const { cnpjCpf, inscricaoEstadual } = dadosOs;

  const handlePageChange = useCallback((newPageNumber) => {
    setPageNumber(newPageNumber);
  }, []);

  const handlePerRowsChange = useCallback((newPageSize) => {
    setPageSize(newPageSize);
    setPageNumber(1);
  }, []);

  const requestSpedEfdHandler = useCallback(() => {
    if ((cnpjCpf !== "" || cnpjCpf !== undefined) && (inscricaoEstadual !== "" || inscricaoEstadual !== undefined)) {
      const params = {
        cnpj: cnpjCpf,
        ie: inscricaoEstadual,
      };
      request(apiRoutes.fiscalizacao.ordemservico.spedEnvioEfd, params);
    }
  }, [request, cnpjCpf, inscricaoEstadual]);

  const handleAnaliticoChange = useCallback(
    (ano, mes) => {
      if (data?.result?.listaEnviosEfd?.length > 0) {
        const analiticos = data?.result?.listaEnviosEfd;
        const listaSpedAnalitico = analiticos.filter((x) => x.ano === ano && x.mes === mes).map((item) => item);
        setTimeout(() => {
          dispacth(spedAction.resetSpedEfdAnalitico());
          dispacth(spedAction.listarSpedEfdAnalitico(listaSpedAnalitico));
        }, 1000);
      }
      if (errors) {
        toast.error(errors.message);
      }
    },
    [data?.result?.listaEnviosEfd, errors, dispacth],
  );

  const handleSinteticoLoad = useCallback(() => {
    if (data?.result?.listaEnviosEfdAnoMes?.length > 0) {
      const itens = itensPagina(data?.result?.listaEnviosEfdAnoMes, pageNumber, pageSize);
      dispacth(spedAction.resetSpedEfdAnalitico());
      dispacth(spedAction.listarSpedEfdSintetico(itens));
      setTotalRows(data?.result?.listaEnviosEfdAnoMes.length);
    }
    if (errors) {
      toast.error(errors.message);
    }
  }, [data?.result?.listaEnviosEfdAnoMes, errors, pageNumber, pageSize, dispacth]);

  const handleDownloadSinteticoLoad = useCallback(() => {
    if (data?.result?.listaEnviosEfdAnoMes?.length > 0) {
      dispacth(spedAction.downloadSpedEfdSintetico(data?.result?.listaEnviosEfdAnoMes));
    }
    if (errors) {
      toast.error(errors.message);
    }
  }, [data?.result?.listaEnviosEfdAnoMes, errors, dispacth]);

  const handleImprimirSintetico = useCallback(
    (obj) => {
      requestDownload(apiRoutes.fiscalizacao.ordemservico.downloadEnvioSpedEfdSintetico, obj);
    },
    [requestDownload],
  );

  const handleImprimirAnalitico = useCallback(
    (obj) => {
      requestDownload(apiRoutes.fiscalizacao.ordemservico.downloadEnvioSpedEfdAnalitico, obj);
    },
    [requestDownload],
  );

  // download
  const handleDownload = useCallback(() => {
    if (dataDownload) {
      const file = new Blob([dataDownload], { type: "application/pdf" });
      const url = URL.createObjectURL(file);
      window.open(url, "", "width=800,height=800").print();
    }
    if (errorDownload) {
      toast.error(errorDownload.message);
    }
  }, [dataDownload, errorDownload]);

  useEffect(() => {
    requestSpedEfdHandler();
  }, [requestSpedEfdHandler]);

  useEffect(() => {
    handleSinteticoLoad();
    handleDownloadSinteticoLoad();
  }, [handleSinteticoLoad, handleDownloadSinteticoLoad]);

  useEffect(() => {
    handleDownload();
  }, [handleDownload]);

  return {
    isLoading,
    totalRows,
    pageSize,
    handlePageChange,
    handlePerRowsChange,
    handleAnaliticoChange,
    handleImprimirSintetico,
    handleImprimirAnalitico,
  };
};

export default useConsultaSped;
